/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OrderSummary = {
    id: number;
    status: OrderSummary.status;
};
export namespace OrderSummary {
    export enum status {
        DRAFT = 'draft',
        NEW = 'new',
        PENDING = 'pending',
        CONFIRMED = 'confirmed',
        PROCESSING = 'processing',
        SHIPPED = 'shipped',
        DELIVERED = 'delivered',
        CANCELLED = 'cancelled',
        RETURNED = 'returned',
    }
}

